// extracted by mini-css-extract-plugin
module.exports = {"slides":"styles_slides__amz72"};